// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2019-01-25T10:29:32Z                      #

// ##############################################################

/**
 * Typ adresy.
 */

/**
 * Klasická adresa.
 */
export const K = 'K';

/**
 * Poštovní přihrádka.
 */
export const P = 'P';

/**
 * Dodávací schrána.
 */
export const D = 'D';

/**
 * Poste restante.
 */
export const R = 'R';

/**
 * Nestrukturovaná adresa.
 */
export const X = 'X';

/**
 * Neuvedena.
 */
export const N = 'N';

/**
 * Seznam všech hodnot.
 */
export const values = [
    K,
    P,
    D,
    R,
    X,
    N
];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
const params = {
    [K]: {caption: 'Klasická adresa.'},
    [P]: {caption: 'Poštovní přihrádka.'},
    [D]: {caption: 'Dodávací schrána.'},
    [R]: {caption: 'Poste restante.'},
    [X]: {caption: 'Nestrukturovaná adresa.'},
    [N]: {caption: 'Neuvedena.'}
};

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
export function getCaption(value) {
    return params[value].caption;
}